import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Modal, Tooltip} from 'antd'
import {ScheduleOutlined, QuestionCircleFilled, EditOutlined, DeleteOutlined, LockOutlined, UnlockOutlined} from '@ant-design/icons'
import FormModal from '../components/FormModal'
import ScheduleModal from '../components/ScheduleModal'
import {withTranslation} from 'react-i18next'
const {confirm} = Modal

@inject('dataFlowMonitoringConfigStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
    scheduleModalVisible: false,
  }

  componentDidMount() {
  }

  handleSchedule = (record) => {
    const {dataFlowMonitoringConfigStore} = this.props
    dataFlowMonitoringConfigStore.onGetJobAction(record.id).then(res => {
      this.setState({
        scheduleModalVisible: true,
      })
    })
  }
  handleCancelSchedule = () => {
    this.setState({
      scheduleModalVisible: false
    })
  }
  handleEdit = (record) => {
    const {dataFlowMonitoringConfigStore} = this.props
    dataFlowMonitoringConfigStore.onGetJobAction(record.id).then(res => {
      this.setState({
        addModalVisible: true,
      })
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  handleDel = (record) => {
    const {dataFlowMonitoringConfigStore,t} = this.props
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        dataFlowMonitoringConfigStore.onDeleteJobAction(record?.id)
      },
      onCancel() {
      },
    })
    return false
  }
  handlePageChange = (page, pageSize) => {
    const {dataFlowMonitoringConfigStore} = this.props
    dataFlowMonitoringConfigStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  handleChangeActive = (record) => {
    const {dataFlowMonitoringConfigStore} = this.props
    dataFlowMonitoringConfigStore.onChangeStatus({
      "enable": record?.enable===0 ? 1 : record?.enable===1 ? 0 : null,
      "id": record?.id,
    })
  }

  render() {
    const {dataFlowMonitoringConfigStore, t} = this.props
    const {pageNo, pageSize, itemCount, jobList} = dataFlowMonitoringConfigStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={toJS(jobList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName} scroll={{x: '110%'}}>
          <Table.Column title={t(`dataFlowMonitoringConfig.dataFlowName`)} dataIndex="name" key="name" ellipsis={true} />
          <Table.Column title={t(`dataFlowMonitoringConfig.dataFlowType`)} dataIndex="type" key="type" ellipsis={true} render={(text, record) => 
            text===0 ? t(`dataFlowMonitoringConfig.realTimeMonitoring`) : text===1 ? t(`dataFlowMonitoringConfig.regularMonitoring`) :null
          } />
          <Table.Column title={t(`dataFlowMonitoringConfig.notificationChannels`)} dataIndex="noticeType" key="noticeType" ellipsis={true} render={(text, record) => 
            text?.map((a, i)=> {
              return a==='DING_TALK_ROBOT' ? i===text?.length-1 ? t(`dataFlowMonitoringConfig.dingding`) : t(`dataFlowMonitoringConfig.dingding`) +',' : a
            })
          } />
          <Table.Column title={t(`dataFlowMonitoringConfig.notificationUser`)} dataIndex="users" key="users" ellipsis={true} render={(text, record) => (
            <Tooltip title={text?.map((a, i)=>{return i===text?.length-1 ? <p>{a?.userName}</p> : <p>{a?.userName +',' }</p>})}>
              {text?.map((a, i)=>{return i===text?.length-1 ? a?.userName : a?.userName +',' })}
            </Tooltip>
          )} />
          <Table.Column title={t(`dataFlowMonitoringConfig.status`)} dataIndex="enable" key="enable" ellipsis={true} render={(text, record) => 
            text===0 ? t(`general.enable`) : text===1 ? t(`general.disable`) :null
          } />
          <Table.Column title={t(`dataFlowMonitoringConfig.dataFlowTime`)} dataIndex="noticeTimeStart" key="noticeTimeStart" ellipsis={true} render={(text, record) => 
            record?.noticeTimeStart +'-'+ record?.noticeTimeEnd
          } />
          <Table.Column title={t(`dataFlowMonitoringConfig.dataFlowGap`)} dataIndex="intervalSecond" key="intervalSecond" ellipsis={true}/>
          <Table.Column title={t(`dataFlowMonitoringConfig.dataFlowCron`)} dataIndex="cron" key="cron" ellipsis={true}/>
          <Table.Column width={200} align="center" fixed='right' title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleEdit(record)} icon={<EditOutlined/>} title={t(`general.edit`)}/>
              {record?.type===0 ? null : <Button type="link" onClick={() => this.handleSchedule(record)} icon={<ScheduleOutlined/>} title={t(`general.schedule`)} />}
              <Button type="link" onClick={() => this.handleChangeActive(record)}
                      icon={record.enable === 0 ? <UnlockOutlined/> : <LockOutlined/>}
                      title={record.enable === 0 ? t(`general.disable`) : t(`general.enable`)}/>
              <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
            </>
          )}/>
        </Table>
        {this.state.scheduleModalVisible ? <ScheduleModal
          scheduleModalVisible={this.state.scheduleModalVisible}
          handleCancel={this.handleCancelSchedule}
        /> : null}
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          title="edit"
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)
